import { ChangeEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';

import { CustomButton, CustomInput } from '../../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../../shared/Helpers/functions';

import { DispatchProperties, useSelector } from '../../../../../../redux/store';
import { addSkillAreas, getSkillAreas, setSkillAreaId } from '../../../../../../redux/State/clientSlice/skillAreaSlice';

export const AddSkillContent = ({ onClose }: { onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const { clientId } = useParams();

	const loading = useSelector((state) => state.skillArea.loading);
	const [name, setName] = useState<string>('');

	const nameHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		setName(value);
	};

	const addSkillAreaHandler = async () => {
		if (!clientId || !name) return;

		dispatch(addSkillAreas({ clientId, name }))
			.then(unwrapResult)
			.then((response) => {
				dispatch(getSkillAreas({ clientId }));
				const { id } = response;
				dispatch(setSkillAreaId(id));
				setName('');
				onClose();
			})
			.catch(errorNormalizer);
	};

	return (
		<div style={{ padding: '16px 0' }}>
			<div style={{ marginBottom: '24px' }}>
				<CustomInput label="Skill name" placeholder="Skill name" value={name} onChange={nameHandler} />
			</div>
			<CustomButton title="Save" onClick={addSkillAreaHandler} disabled={!name.trim()} loading={loading} />
		</div>
	);
};
